import context from '../context'
import { processUserReport } from '@/store/utils/reportUtils'
import { allowErrorDialog } from '@/utils/fetch'
import getComponentKey from '@/utils/getComponentKey'

const initialState = {
  loading: false,
  reportDetail: null,
  reportDetailData: [],

  reportTemplateLoading: false,
  reportTemplate: null,
  reportTemplateUpdating: false,
  gridKey: getComponentKey(),
  dialogKey: getComponentKey()
}

const actionTypes = {
  contentLoading: 'reportTemplateVersion/loading',
  contentLoaded: 'reportTemplateVersion/loaded',
  clearReportDetail: 'reportTemplateVersion/clear',
  getSubmittedReportDetail: 'reportTemplateVersion/getReportTemplateDetail',

  reportTemplateLoading: 'reportTemplate/loading',
  reportTemplateLoaded: 'reportTemplate/loaded',
  reportTemplateUpdating: 'reportTemplate/updating',
  reportTemplateUpdated: 'reportTemplate/updated',
  error: 'reportTemplate/error'
}

const actionCreators = {
  // this is actually loading ReportTemplateVersion, not ReportTemplate
  getReportTemplateDetail: (id) => (dispatch, getState) => {
    const state = getState()

    if (state.reportTemplate.contentLoaded && state.reportTemplate.reportDetail.id === id) return

    dispatch({ type: actionTypes.clearReportDetail })

    dispatch({ type: actionTypes.contentLoading })
    context.api.reportTemplateService.getReport(id, allowErrorDialog)
      .then(response => {
        dispatch({ type: actionTypes.getSubmittedReportDetail, data: processUserReport(response) })

        dispatch({ type: actionTypes.contentLoaded })
      }).catch(() => dispatch({ type: actionTypes.error, update: { loading: false } }))
  },
  getReportTemplate: (id) => (dispatch) => {
    dispatch({ type: actionTypes.reportTemplateLoading })
    context.api.reportTemplateService.getReportTemplate(id, allowErrorDialog)
      .then(response => dispatch({ type: actionTypes.reportTemplateLoaded, payload: response }))
      .catch(() => dispatch({ type: actionTypes.error, update: { reportTemplateLoading: false } }))
  },
  updateReportTemplate: (dto, callback) => (dispatch) => {
    dispatch({ type: actionTypes.reportTemplateUpdating })
    context.api.reportTemplateService.updateReportTemplateCategory(dto, allowErrorDialog)
      .then(() => {
        dispatch({ type: actionTypes.reportTemplateUpdated })
        if (typeof callback === 'function') { callback() }
      })
      .catch(() => dispatch({ type: actionTypes.error, update: { reportTemplateUpdating: false } }))
  },
  editReportTemplateDisabled: (id, isDisabled) => (dispatch) => {
    if (isDisabled === true) {
      context.api.reportTemplateService.activateReportTemplate(id)
        .then(() => dispatch({ type: actionTypes.reportTemplateUpdated }))
        .catch(() => dispatch({ type: actionTypes.error, update: { reportTemplateUpdating: false } }))
    } else {
      context.api.reportTemplateService.deactivateReportTemplate(id)
        .then(() => dispatch({ type: actionTypes.reportTemplateUpdated }))
        .catch(() => dispatch({ type: actionTypes.error, update: { reportTemplateUpdating: false } }))
    }
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.contentLoading:
    {
      state = { ...state, loading: true }
      break
    }
    case actionTypes.contentLoaded:
    {
      state = { ...state, loading: false }
      break
    }
    case actionTypes.getSubmittedReportDetail:
    {
      state = { ...state, reportDetail: action.data }
      break
    }
    case actionTypes.clearReportDetail:
    {
      state = { ...state, reportDetail: null, reportDetailData: [] }
      break
    }
    case actionTypes.reportTemplateLoading: return { ...state, reportTemplateLoading: true }
    case actionTypes.reportTemplateLoaded: return { ...state, reportTemplateLoading: false, reportTemplate: action.payload, dialogKey: getComponentKey() }
    case actionTypes.reportTemplateUpdating: return { ...state, reportTemplateUpdating: true }
    case actionTypes.reportTemplateUpdated: return { ...state, reportTemplateUpdating: false, gridKey: getComponentKey() }
    case actionTypes.error: return { ...state, ...action.update }
    default:
    {}
  }
  return state
}

export { actionCreators, reducer }



// WEBPACK FOOTER //
// ./src/store/ReportTemplate.js